import React, { useEffect, useState } from "react";
import { Loader } from "../Loader/Loader";
import { Avatar, Badge, Input, Empty, message, Button, Tabs } from "antd";
import { Modal } from "antd";
import socket from "../socket-io";
import consts from "../consts";
import {
  MenuUnfoldOutlined,
  ArrowLeftOutlined,
  SendOutlined,
  SmileOutlined,
} from "@ant-design/icons";
import avar from "../Assets/avar.png";
import fav from "../Assets/favicon.png";
import { motion } from "framer-motion";
import Axios from "../Axios";
import { useLayout } from "../Context/LayoutContext";
import { Grid } from "antd";

const { useBreakpoint } = Grid;
const { TextArea } = Input;
// const socket = io(consts.socketUrl);


const Support = ({ loader, setCollapsed }) => {
  // const [chat, setChat] = useState(false);
  const{chat,setChat} = useLayout()
  const screen = useBreakpoint()
  const [chatMessages, setChatMessages] = useState([]); // <-- store messages in state
  const [noData, setNodata] = useState(false);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [roomId, setRoomId] = useState("");
  const [messageApi, contextHolder] = message.useMessage();
  const [tickets, setTickets] = useState([]);
  const [messages, setMessages] = useState([]);
  const [messageInput, setMessageInput] = useState("");
  const [queryId, setQueryId] = useState("");
  const [status, setStatus] = useState(false);
  const [chatTitle, setChatTitle] = useState("");
  // const [dropdownOpen, setDropDown] = useState(false)
  const [chatStatus, setChatStatus] = useState(false);
  const [inputTicket, setInputTicket] = useState({
    title: "",
    message: "",
  });
  const getTickets = async () => {
    setLoading(true);
    try {
      let response = await Axios.post(
        "/support/getallquery",
        { status },
        {
          headers: {
            Authorization: localStorage.getItem("nzanzi"),
          },
        }
      );
      const data = await response?.data;
      if (data?.success) {
        setTickets(data?.result);
      } else {
        setTickets([]);
      }
    } catch (error) {
      console.log(error);
      setTickets([]);
    } finally {
      setLoading(false);
    }
  };
  const getMessage = async (queryid) => {
    setLoading(true);
    try {
      let response = await Axios.post(
        "/support/getallquery",
        { queryid },
        {
          headers: {
            Authorization: localStorage.getItem("nzanzi"),
          },
        }
      );
      const data = await response?.data;
      if (data?.success) {
        setMessages(data?.result?.Answer);
        setChatStatus(data?.result?.solved);
        setChatTitle(data?.result?.title);
      } else {
        setMessages([]);
        setChatStatus(false);
        setChatTitle("");
      }
    } catch (error) {
      console.log(error);

      setMessages([]);
      setChatStatus(false);
      setChatTitle("");
    } finally {
      setLoading(false);
    }
  };
  const showModal = () => {
    setOpen(true);
  };

  const handleOk = async () => {
    setLoading(true);
    try {
      if (inputTicket.title.trim() === "") {
        messageApi.open({
          type: "error",
          content: "Please enter a title",
        });
        return;
      }
      if (inputTicket.message.trim() === "") {
        messageApi.open({
          type: "error",
          content: "Please enter a message",
        });
        return;
      }
      const response = await Axios.post("/support/addquery", inputTicket, {
        headers: {
          Authorization: localStorage.getItem("nzanzi"),
        },
      });
      const data = await response?.data;
      if (data?.success) {
        setInputTicket({
          title: "",
          message: "",
        });
        setOpen(false);
        setStatus(false);
        socket.emit("join_support_room", { room: data?.result?.roomid });
        getTickets();
        messageApi.open({
          type: "success",
          content: "Ticket Created",
        });
      }
    } catch (error) {
      console.log(error);
      messageApi.open({
        type: "error",
        content: error?.response?.data?.message || "Something went wrong",
      });
      setOpen(false);
    } finally {
      setLoading(false);
    }

    const onChange = (key) => {
      console.log(key);
    };
  };

  const handleCancel = () => {
    console.log("Clicked cancel button");
    setInputTicket({
      title: "",
      message: "",
    });
    setOpen(false);
  };

  const openChat = async (ticketid, roomid) => {
    setChat(true);
    setQueryId(ticketid);
    getMessage(ticketid);

    socket.emit("leave_support_room");
    socket.emit("join_support_room", { room: roomid });
    // load fresh messages when entering chat
  };

  const closeChat = () => {
    setChat(false);
    socket.emit("leave_support_room");
    getTickets();
    setMessages([]);
    setMessageInput("");
    setChatTitle("");
    setStatus(false);
  };

  const handleTicketInputs = (e) => {
    setInputTicket({
      ...inputTicket,
      [e?.target?.name]: e?.target?.value,
    });
  };

  const sendMessage = async (queryId) => {
    setLoading(true);
    try {
      if (messageInput.trim() === "") {
        return;
      }
      const response = await Axios.post("/support/reply", {
        queryId,
        reply: messageInput,
      });
      const data = await response?.data;
      if (data?.success) {
        setMessageInput("");
      }
    } catch (error) {
      console.log(error);
      messageApi.open({
        type: "error",
        content: error?.response?.data?.message || "Something went wrong",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTickets();
  }, [status]);

  useEffect(() => {
    // getTickets();
    socket.on("receive_raised_ticket", (data) => {
      getTickets();
    });

    socket.on("receive_reply", (data) => {
      console.log("📩 New reply received:", data);
      setTickets((prev) => {
        return prev.map((chat) => {
          if (chat?._id === data?.queryid) {
            return {
              ...chat,
              unreadCount: data?.role === "admin" && chat?.unreadCount + 1,
            };
          }
          return chat;
        });
      });
      setMessages((prev) => {
        const allSeen = data?.role === "admin";

        if (allSeen) {
          return [
            ...prev.map((msg) => ({ ...msg, seen: true })),
            { ...data, seen: true },
          ];
        }

        return [...prev, { ...data, seen: false }];
      });
    });

    socket.on("receive_close_ticket", (data) => {
      setChatStatus(true);
      getTickets();
    });
    return () => {
      socket.off("receive_reply");
      socket.off("getallqueries");
    };
  }, [messages, status]);

  const onChange = (key) => {
    console.log(key, "onchangekey");
    setStatus((prev) => (prev === false ? true : false));
  };

  const formatChatMessageTime = (createdAt) => {
    const msgDate = new Date(createdAt);
    const today = new Date();

    const isToday =
      msgDate.getDate() === today.getDate() &&
      msgDate.getMonth() === today.getMonth() &&
      msgDate.getFullYear() === today.getFullYear();

    return isToday
      ? msgDate.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
      : msgDate.toLocaleDateString();
  };
  const items = [
    {
      key: "1",
      label: "OPEN",
      children: (
        <>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.3 }}
          >
            {tickets?.length > 0 && (
              tickets.map((ticket) => (
                <div
                  id="cs"
                  className="display-1  p-10 cursor hov-sup"
                  onClick={() => openChat(ticket?._id, ticket?.roomid)}
                  style={{ margin: "5px 3px" }}
                >
                  <Badge
                    dot
                    offset={[-3, 35]}
                    style={{ width: "8px", height: "8px" }}
                    color={"#009A2D"}
                  >
                    <Avatar src={fav} size={44} />
                  </Badge>
                  <div className="chat-txt">
                    {ticket?.title}
                    <div className="chat-desc">
                      {ticket?.Answer[0]?.reply?.slice(0, 20)}
                    </div>
                  </div>

                  <Badge
                    className="site-badge"
                    count={`${ticket?.unreadCount > 0 ? `${ticket?.unreadCount}` : ""
                      }`}
                    style={{ backgroundColor: "#7C808A" }}
                  />
                </div>
              ))
            )}
          </motion.div>
          {tickets?.length < 0 &&
            <div style={{ display: 'flex', flex: '1', alignItems: 'center', justifyContent: "center" }}>
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />

            </div>}
          <div className="create-ticket">
            <Button onClick={showModal}>Create Ticket</Button>
          </div>
        </>
      ),
    },
    {
      key: "2",
      label: "CLOSED",
      children: (
        <div className="">
          {tickets?.length > 0 ? (
            tickets.map((ticket) => (
              <div
                id="cs"
                className="display-1  p-20 cursor hov-sup"
                onClick={() => openChat(ticket?._id, ticket?.roomid)}
              >
                <Badge
                  dot
                  offset={[-3, 35]}
                  style={{ width: "8px", height: "8px" }}
                  color={"#009A2D"}
                >
                  <Avatar icon={<MenuUnfoldOutlined />} size={44} />
                </Badge>
                <div className="chat-txt">
                  {ticket?.title}
                  {/* {ticket?.unreadCount > 0 ? `(${ticket?.unreadCount})` : ""} */}
                  <div className="chat-desc">
                    {ticket?.Answer[0]?.reply?.slice(0, 20)}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          )}
        </div>
      ),
    },
  ];

  return (
    <>
      {loader ? (
        <Loader />
      ) : chat ? (
        <>
          {/* Chat Header */}

          <div className="display-5 p-20 trad-pos">
            <div className="display-1 gap-15">
              <ArrowLeftOutlined
                className="cursor"
                style={{ fontSize: "20px", color: "var(--fnt)" }}
                onClick={closeChat}
                id="cs"
              />
              <div className="side-title">
                {chatTitle || "Support"}
                {/* <div className="display-1 chat-desc v2">
                  <div className="dot" />
                  Online
                </div> */}
              </div>
            </div>
            <div className="cursor" onClick={() => setCollapsed(true)} id="cs">
              <svg
                width="17"
                height="17"
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.0215 1.70605C13.6494 1.07837 14.6661 1.07823 15.2939 1.70605C15.9218 2.33389 15.9208 3.34966 15.293 3.97754L15.2939 3.97852L10.7725 8.5L15.2939 13.0215C15.9217 13.6494 15.9209 14.6652 15.293 15.293C14.9799 15.6061 14.5678 15.7646 14.1572 15.7646C13.7469 15.7646 13.3345 15.6068 13.0215 15.2939L8.5 10.7725L3.97852 15.2939C3.66549 15.6068 3.25314 15.7646 2.84277 15.7646C2.43255 15.7646 2.02021 15.6063 1.70703 15.293C1.07904 14.6652 1.07825 13.6494 1.70605 13.0215L6.22754 8.5L1.70605 3.97852C1.0782 3.35062 1.07812 2.3339 1.70605 1.70605C2.33401 1.0781 3.35056 1.07844 3.97852 1.70605L8.5 6.22754L13.0215 1.70605Z"
                  fill="#82858E"
                  stroke="#82858E"
                  stroke-width="1.5294"
                />
              </svg>
            </div>
          </div>

          {/* Chat Body */}

          <div className="chat-body">
            {noData ? (
              <Empty
                description="No Chat Found"
                style={{ color: "#fff" }}
                className="empty"
              />
            ) : (
              messages.map((msg) => (
                <div className={`chat-message ${msg?.role}`}>
                  {msg.role === "admin" && (
                    <Avatar
                      src={`https://cdn-icons-png.flaticon.com/512/4712/4712109.png`}
                      className="chat-avatar"
                    />
                  )}
                  <div className="chat-bubble">
                    <div>{msg?.reply}</div>
                    <div
                      className="chat-timestamp"
                      style={{ fontSize: "10px" }}
                    >
                      <span>{formatChatMessageTime(msg?.createdAt)}</span>{" "}
                      {msg?.role === "user" && (
                        <span>
                          {msg?.seen ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width={20}
                              height={20}
                              fill={"#4501e6ff"}
                            >
                              <path d="M1.6 13.2l1.4-1.4 3.2 3.2 7.2-7.2 1.4 1.4-8.6 8.6z" />
                              <path d="M7.8 13.2l1.4-1.4 3.2 3.2 7.2-7.2 1.4 1.4-8.6 8.6z" />
                            </svg>
                          ) : (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width={20}
                              height={20}
                              fill={"#fff"}
                            >
                              <path d="M1.6 13.2l1.4-1.4 3.2 3.2 7.2-7.2 1.4 1.4-8.6 8.6z" />
                              <path d="M7.8 13.2l1.4-1.4 3.2 3.2 7.2-7.2 1.4 1.4-8.6 8.6z" />
                            </svg>
                          )}
                        </span>
                      )}
                    </div>
                  </div>
                  {msg.role === "user" && (
                    <Avatar
                      src={`https://cdn-icons-png.flaticon.com/512/1077/1077012.png`}
                      className="chat-avatar"
                    />
                  )}
                </div>
              ))
            )}
          </div>

          {/* Chat Input */}

          <div className="chat-input-container">
            {chatStatus ? (
              <div style={{ color: "white", textAlign: "center" }}>
                Ticket Closed
              </div>
            ) : (
              <>
                <Input
                  placeholder="Type a message"
                  value={messageInput}
                  onChange={(e) => setMessageInput(e.target.value)}
                  className="chat-input"
                  bordered={false}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault();
                      sendMessage(queryId);
                    }
                  }}
                />

                <SendOutlined
                  className="chat-icon"
                  onClick={() => sendMessage(queryId)}
                />
              </>
            )}
          </div>
        </>
      ) : (
        <>
          {/* Support List */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.3 }}
            style={{ display: "flex", flexDirection: "column", flex: "1" }}
          >
         {screen.lg &&   <div className="display-5 p-20">
              <div className="side-title">Chats & Support</div>
              <div
                className="cursor nonea3"
                onClick={() => setCollapsed(true)}
                id="cs"
              >
                <svg
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.0215 1.70605C13.6494 1.07837 14.6661 1.07823 15.2939 1.70605C15.9218 2.33389 15.9208 3.34966 15.293 3.97754L15.2939 3.97852L10.7725 8.5L15.2939 13.0215C15.9217 13.6494 15.9209 14.6652 15.293 15.293C14.9799 15.6061 14.5678 15.7646 14.1572 15.7646C13.7469 15.7646 13.3345 15.6068 13.0215 15.2939L8.5 10.7725L3.97852 15.2939C3.66549 15.6068 3.25314 15.7646 2.84277 15.7646C2.43255 15.7646 2.02021 15.6063 1.70703 15.293C1.07904 14.6652 1.07825 13.6494 1.70605 13.0215L6.22754 8.5L1.70605 3.97852C1.0782 3.35062 1.07812 2.3339 1.70605 1.70605C2.33401 1.0781 3.35056 1.07844 3.97852 1.70605L8.5 6.22754L13.0215 1.70605Z"
                    fill="#82858E"
                    stroke="#82858E"
                    stroke-width="1.5294"
                  />
                </svg>
              </div>
            </div>}
            <Tabs
              defaultActiveKey="1"
              items={items}
              onChange={onChange}
              className="promo-tab"
              id="cs"
              style={{ height: "100%" }}
            />
          </motion.div>

          {/* </motion.div> */}
        </>
      )}

      <Modal
        title="Create Ticket"
        open={open}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        className="model"
        footer={[
          <Button
            key="back"
            color="default"
            variant="outlined"
            onClick={handleCancel}
            style={{
              background: "red",
              color: "#fff",
              borderColor: "red",
            }}
            className="tkt-opahover"
          >
            Cancel
          </Button>,
          <Button
            loading={loading}
            key="submit"
            type="primary"
            onClick={handleOk}
            style={{ background: "#009A2D" }}
            className="tkt-opahover"
          >
            Create
          </Button>,
        ]}
      >
        <Input
          placeholder="Title"
          name="title"
          value={inputTicket?.title}
          style={{ background: "var(--bg-mn)" }}
          onChange={handleTicketInputs}
        />
        <div className="mt-10">
          <TextArea
            rows={4}
            name="message"
            value={inputTicket?.message}
            placeholder="Reason"
            style={{ background: "var(--bg-mn)" }}
            onChange={handleTicketInputs}
          />
        </div>
      </Modal>
      {contextHolder}
    </>
  );
};

export default Support;
